module.exports = __webpack_public_path__ + "202408221624/img/chayao.39c3dcb4.png";